import React from "react";
import { compose, graphql } from "react-apollo";

import { GET_ACTIVITY_FEED } from "../../graphql/queries";
import { GET_TABLE_PARAMS } from "../../cacheql/queries";
import { SET_TABLE_PARAMS } from "../../cacheql/mutations";
import { getCardParams } from "../../utils/helpers";
import ActivityFeedList from "./activity-feed-list";
import { useActivityFeedScope } from "./activity-feed-scope-context";
import { getActivityFeedTypesForCategory } from "./activity-feed-list-utils";

const mapScopeCommunityIds = (communityIds) => {
  if (!communityIds?.length) return undefined;
  return communityIds
    .filter((id) => id !== -1 && id != null)
    .map((id) => Number(id))
    .filter((id) => !Number.isNaN(id));
};

const ActivityFeedListWithScope = (props) => {
  const {
    initialized,
    division,
    communityIds,
    customerFilter,
    activityTypeCategory,
    startDate,
    endDate,
  } = useActivityFeedScope();
  const scopeCommunityIds = mapScopeCommunityIds(communityIds);
  const scopeActivityTypes =
    getActivityFeedTypesForCategory(activityTypeCategory) || null;

  return (
    <ActivityFeedListConnected
      key={`${division?.id ?? "all-div"}-${
        scopeCommunityIds?.join(",") ?? "all-comm"
      }-${activityTypeCategory}-${startDate ?? "no-start"}-${
        endDate ?? "no-end"
      }`}
      {...props}
      scopeInitialized={initialized}
      scopeDivisionId={division?.id}
      scopeCommunityIds={scopeCommunityIds}
      scopeCustomerIds={customerFilter?.customerIds}
      scopeActivityTypes={scopeActivityTypes}
      scopeActivityTypeCategory={activityTypeCategory}
      scopeStartDate={startDate}
      scopeEndDate={endDate}
    />
  );
};

const ActivityFeedListConnected = compose(
  graphql(SET_TABLE_PARAMS, { name: "setTableParams" }),
  graphql(GET_TABLE_PARAMS, { name: "getTableParams" }),
  graphql(GET_ACTIVITY_FEED, {
    options: ({
      customerType,
      cardTitle,
      getTableParams: { tableParams },
      scopeDivisionId,
      scopeCommunityIds,
      scopeCustomerIds,
      scopeActivityTypes,
      scopeActivityTypeCategory,
      scopeStartDate,
      scopeEndDate,
      scopeInitialized,
    }) => {
      const params = getCardParams(cardTitle, tableParams);
      const typeMatches =
        params?.activityTypeCategory === scopeActivityTypeCategory;
      const dateMatches =
        params?.activityStartDate === scopeStartDate &&
        params?.activityEndDate === scopeEndDate;
      const filtersMatch = typeMatches && dateMatches;

      return {
        skip: !scopeInitialized,
        notifyOnNetworkStatusChange: true,
        variables: {
          filter: {
            community_ids: scopeCommunityIds,
            division_id: scopeDivisionId,
            customer_types: customerType ? [customerType] : undefined,
            customer_ids: scopeCustomerIds?.length
              ? scopeCustomerIds
              : undefined,
            ...(scopeActivityTypes?.length
              ? { activity_types: scopeActivityTypes }
              : {}),
            ...(scopeStartDate
              ? { activity_start_datetime: scopeStartDate }
              : {}),
            ...(scopeEndDate ? { activity_end_datetime: scopeEndDate } : {}),
          },
          // Reset to page 0 when Types / Dates filters change (before card params catch up)
          pageNum: filtersMatch ? params?.pageNum || 0 : 0,
          limit: (params && params.limit) || 10,
        },
        fetchPolicy: "network-only",
      };
    },
  })
)(ActivityFeedList);

export default ActivityFeedListWithScope;
